import http from "../http";

export default (axios, base) => ({
  statistic: (type) => {
    return http.get(`${base}/statistic?type=${type}`);
  },
  userOnline: () => http.get(`${base}/online`),
});
